import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import CityDrawer from "components/drawer/CityDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

const CityTable = ({
  citydata,
  // hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <CityDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {citydata?.slice(0, ).map((data, index) => (
        
          
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">
              { index + 1}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data.name}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.state_name}
              {/* {console.log(data.country_name)} */}
            </TableCell>
            <TableCell className="text-center text-xs">
              {data.country_name}
              {/* {console.log(data.country_name)} */}
            </TableCell>
            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                
                  id={data.id_city}
                  title={data.name}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  // hideDelete={hideDelete}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default CityTable;
